import { ENTITY_FIELD_TYPE, SCHEMA_TYPE } from 'constants/index';

// Type-based API: a custom-object relationship target is addressed by its type (related_entity_type, or
// field_options.custom_object_id), while the response can also carry the numeric entity id in related_entity_id -
// which is not valid in type-based URLs (.../entities/type/<type>/...). The UI reads related_entity_id everywhere,
// so for custom-object targets surface the type there (mirrors transformRelationshipFieldForPut, which maps it back on
// save). Native targets keep related_entity_id.
const normalizeRelationshipTarget = field => {
  if (field?.type !== ENTITY_FIELD_TYPE.RELATIONSHIP) return field;
  const options = field.field_options ?? {};
  if (options.related_object_type === SCHEMA_TYPE.NATIVE || options.lego_related_object_type === SCHEMA_TYPE.NATIVE) return field;
  const targetType = field.related_entity_type ?? options.custom_object_id;
  return targetType == null ? field : { ...field, related_entity_id: targetType };
};

export const normalizeEntityForUi = entity => {
  if (!entity) return entity;
  return {
    ...entity,
    ...(Array.isArray(entity.fields) && { fields: entity.fields.map(normalizeRelationshipTarget) }),
    form_options: entity.form_options,
    icon_link: entity.icon_link ?? entity.form_options?.icon,
  };
};

const isResponseForEntityList = response => Array.isArray(response?.entities);

export const normalizeEntityListResponse = response => {
  if (!isResponseForEntityList(response)) return response;
  return {
    ...response,
    schemas: response.entities.map(normalizeEntityForUi),
  };
};

export const normalizeEntityResponse = response => {
  if (!response) return response;
  if (isResponseForEntityList(response)) return normalizeEntityListResponse(response);
  return normalizeEntityForUi(response);
};
